import { nanoid } from "nanoid";
import { LINE_ORIENTATIONS, SHAPE_TYPES, ShapeType } from "../../../../types";
import {
  DEFAULT_COLOR,
  DEFAULT_LINE_THICKNESS,
  DEFAULT_SHAPE_SIZE,
} from "../../../../constants";

export const getShapeId = (
  shapeType: ShapeType,
  newShapeNamePrefix?: string
) => {
  return `${newShapeNamePrefix}-${shapeType}-${nanoid()}`;
};

export const generateNewShape = (
  shapeType: ShapeType,
  previewWidth: number,
  previewHeight: number,
  newHighestLayerIndex: number,
  newShapeNamePrefix?: string
) => {
  const height =
    shapeType === SHAPE_TYPES.LINE
      ? DEFAULT_LINE_THICKNESS
      : DEFAULT_SHAPE_SIZE;
  const width = (DEFAULT_SHAPE_SIZE * previewHeight) / previewWidth;
  const commonProps = {
    id: getShapeId(shapeType, newShapeNamePrefix),
    shapeType,
    size: {
      width,
      height,
    },
    position: {
      x: (1 - width) / 2,
      y: (1 - height) / 2,
    },
    background: DEFAULT_COLOR,
    layerIndex: newHighestLayerIndex,
  };

  switch (shapeType) {
    case SHAPE_TYPES.RECTANGLE:
    case SHAPE_TYPES.CIRCLE:
      return {
        ...commonProps,
      };
    case SHAPE_TYPES.LINE:
      return {
        ...commonProps,
        orientation: LINE_ORIENTATIONS.HORIZONTAL,
      };
  }
};
